module.exports = __webpack_public_path__ + "img/va-logo.32593b34.jpg";